import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { setHeading } from "../../../accounts/account.actions";
// import _ from 'lodash'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { DeleteJobDocumentApi } from "./JobAction";



const DetailJobView = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { fromPath, JobViewDetails } = location.state || {};

    useEffect(() => {
        props.setHeading("View Job Details");
    });

    const handleDelete = (image, index, jobId) => {
        const data = { jobId: jobId, documentId: image._id }
        props.DeleteJobDocumentApi(data)
        navigate("/crm/job/ViewJob")
    };

    return (
        <>
            <div>
                {JobViewDetails ? (
                    <div>

                        <div style={{ textAlign: 'center', marginBottom: '35px' }}>
                            <Link to={fromPath}>
                                <Button variant="contained" endIcon={<ArrowBackIcon />} size="large" style={{ fontWeight: 'bold' }}> BACK TO LIST </Button>
                            </Link>
                        </div>

                        <div style={{ backgroundColor: '#aed6ae', padding: '15px', borderRadius: '25px', marginBottom: '35px' }}>
                            <Row>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Job Number: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{JobViewDetails?.sequenceNumber}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Job Status: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{JobViewDetails?.jobStatus}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Job Date:  <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{JobViewDetails?.startDate}</span> </b></Col>
                            </Row>
                            <Row>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Financial Year: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{JobViewDetails?.financialYear}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Job Fee: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{JobViewDetails?.jobFee}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Company Name: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{JobViewDetails?.customerId?.companyName}</span> </b></Col>
                            </Row>
                            <Row>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Service Name: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{JobViewDetails?.productId?.productName}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Team Member: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{JobViewDetails?.teamMemberId?.name}</span> </b></Col>
                                <Col></Col>
                            </Row>
                        </div>

                        <div style={{ marginTop: '20px' }}>
                            {JobViewDetails?.documents.map((doc, index) => {
                                const fileExtension = doc.documentURL.split('.').pop().toLowerCase();
                                const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension);
                                const isPDF = fileExtension === 'pdf';

                                return (
                                    <div key={index} style={{ float: 'left', marginRight: '15px', textAlign: 'center' }}>

                                        {/* Document Type Heading */}
                                        <div style={{ marginBottom: '5px', fontWeight: 'bold', fontSize: '14px' }}>
                                            {doc.documentTypeName || 'Unknown Document Type'}
                                        </div>

                                        {/* Document Box */}
                                        <div
                                            style={{
                                                position: 'relative',
                                                display: 'inline-block',
                                                width: '160px',
                                                height: '160px',
                                                border: '1px solid #ccc',
                                                borderRadius: '8px',
                                                overflow: 'hidden',
                                                textAlign: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: '#f9f9f9',
                                            }}
                                        >
                                            <a
                                                href={doc.documentURL}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ textDecoration: 'none', color: 'inherit' }}
                                            >
                                                {isImage ? (
                                                    <img
                                                        src={doc.documentURL}
                                                        alt="document"
                                                        width="160px"
                                                        height="160px"
                                                        style={{ display: 'block', objectFit: 'cover' }}
                                                    />
                                                ) : isPDF ? (
                                                    <div style={{ paddingTop: '30px' }}>
                                                        <PictureAsPdfIcon style={{ fontSize: 60, color: '#d32f2f' }} />
                                                        <p>View PDF</p>
                                                    </div>
                                                ) : (
                                                    <div style={{ paddingTop: '30px' }}>
                                                        <InsertDriveFileIcon style={{ fontSize: 60, color: '#1976d2' }} />
                                                        <p>Download File</p>
                                                    </div>
                                                )}
                                            </a>

                                            <IconButton
                                                onClick={() => handleDelete(doc, index, JobViewDetails._id)}
                                                style={{
                                                    position: 'absolute',
                                                    top: '5px',
                                                    right: '5px',
                                                    backgroundColor: 'rgba(2, 2, 2, 0.8)',
                                                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                                                }}
                                                size="small"
                                                aria-label="delete"
                                            >
                                                <DeleteForeverIcon style={{ color: 'rgba(255, 255, 255, 0.8)' }} />
                                            </IconButton>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>


                    </div>

                ) : (
                    <div style={{ textAlign: "center" }}>
                        <h5> Data Not Found</h5>
                        <div style={{ textAlign: 'center', marginBottom: '35px' }}>
                            <Link to={fromPath}>
                                <Button variant="contained" endIcon={<ArrowBackIcon />} size="large" style={{ fontWeight: 'bold' }}> BACK TO LIST </Button>
                            </Link>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        setHeading: (data) => dispatch(setHeading(data)),
        DeleteJobDocumentApi: (data) => dispatch(DeleteJobDocumentApi(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingJobWithId: state.JobReducer.isFetchingJobWithId,
    jobWithIdList: state.JobReducer.jobWithIdList,
});

export default connect(mapStateToProps, mapDispatchToProps)(DetailJobView);